import users from './repositories/users.js';
import clients from './repositories/clients.js';
import { Brands as brands } from './repositories/brands';
import customRoles from './repositories/custom-roles';
import contactsVerification from './repositories/contacts-verification';
// organization-service, not auth-service — exposed here so callers keep using useApi().organizations.
import organizations from '../OrganizationService/repositories/organizations';
import type { Api } from '@@/types/Api.js';

export function createAPI(): Api {
  return {
    users: users(),
    clients: clients(),
    brands: brands(),
    customRoles: customRoles(),
    contactsVerification: contactsVerification(),
    organizations: organizations(),
  };
}
